<div *ngIf="!!eaOid" (click)="openModal($event)" class="contact-summary-icon">
  <app-icon name="bolt" size="none"></app-icon>
</div>
